<template>

    <div class="profile-wrap favorite-player-list">
        <div class="profile">
            <div class="profile-content">
                <div class="profile-info-wrap">
                    <p class="name">{{user.userName}}</p>
                    <p>{{changeBirthDay(user.dateOfBirth)}} {{user.gender === 'M' ? '남성' : '여성'}}</p>
                    <div class="float-content">
                        <p>2020 전적</p>
                        <div>
                            <span>5전</span>
                            <span>3승</span>
                            <span>2패</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props: ['user']
    }
</script>
